import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../image/other-bg.png'
import _imports_1 from '@/assets/link.png'


const _withScopeId = n => (_pushScopeId("data-v-5be6e7f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "it" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "it_img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "it_title" }, "智联终端", -1))
const _hoisted_4 = { class: "it_container" }
const _hoisted_5 = { class: "it_card" }
const _hoisted_6 = { class: "it_cardImgContainer" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "it_cardTitle" }
const _hoisted_9 = { class: "it_cardContent" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "it_list" }, null, -1))

import { Autoplay } from 'swiper7'
import { Swiper as SwiperType } from 'swiper7/types';
import { Swiper, SwiperSlide, } from 'swiper7/vue/swiper-vue.js';
import 'swiper7/swiper-bundle.min.css'
import { ref } from 'vue';
import irCameraImage from '../image/it/camera.jpg';
import irCameraImage2 from '../image/it/net-camera.jpg';
import linweishi from '../image/it/linweishi.jpg';
import pancam from '../image/it/panorama.jpg';
import commandCenter from '../image/it/command-center.jpg';
/**
 * 获取swiper实例
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'It',
  setup(__props) {

const swiperInstance = ref();
const setSwiperInstance = (swiper: SwiperType) => {
  swiperInstance.value = swiper;
}

const list = ref([
  { url: irCameraImage2 , to: '/ir-camera2', title: '红外相机（联网款）', content: '红外相机能在野外长期监测，自动获取大量的野生动物的静态图片以及动态视频，并通过网络传输至红外相机监测自动识别系统，可进行图像展示、物种识别、统计分析、生成专题图等，为生态保护、综合科考、本底调查、动物行为学研究、动物种群数量调查、生物多样性保护等科研监测和科普宣教工作提供丰富的影像数据。' },
  { url: irCameraImage, to: '/ir-camera', title: '红外相机（标准版）', content: '红外相机能在野外长期监测，将回收的数据进行一键上传，并通过网络传输至红外相机监测自动识别系统，系统可进行图像展示、物种识别、统计分析、生成专题图等，为生态保护、综合科考、本底调查、动物行为学研究、动物种群数量调查、生物多样性保护等科研监测和科普宣教工作提供丰富的影像数据，且具有布设简单、监测周期长、隐蔽性高、学习成本低、相对廉价等特点。' },
  { url: commandCenter, to: '/command-center', title: '智慧大屏', content: '室内大屏幕显示解决方案供应商，产品涵盖网格背投、LCD、LED等，广泛应用于智能会议室、生态监测中心、科普宣教馆、智慧林长综合管理中心、林火监控指挥中心等方面。' },
  { url: linweishi, to: '/linweishi', title: '林卫视', content: '林卫视森林防火智能宣教终端，是目前集成度最高的森林防火宣教监测设备，利用物联网传感器、无线通信及成像技术，自动抓拍往来人员、车辆视频图像，自动触发针对性语音、文字提示，加强森林防火意识，及时有效的对往来人员进行防火宣教，让森林防火宣教的科技水平和防控能力不断提升。' },
  { url: pancam, to: '/pancam', title: '全景监测站', content: '720°全景监测基站集成摄像头、光感传感器、空气温湿度传感器，实现720°高清图像、环境温度、湿地、大气压和光照强度等数据的实时采集和远程监控。' },
])
const handleSwiperClick = (swiper: SwiperType) => {
  const index = swiper.clickedSlide.dataset.swiperSlideIndex;
  swiper.slideToLoop(Number(index), 200)
}



const handleProgress = (swiper: SwiperType, progress: number) => {
  swiper.slides.forEach((item: any, index) => {
    const slideProgress = item.progress;
    let modify = 1;
    if (Math.abs(slideProgress) > 1) {
      modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
    }
    let translate = (slideProgress * modify * 100) + 'px';
    let scale = 1 - Math.abs(slideProgress) / 5;
    let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
    item.style.transform = `translateX(${translate}) scale(${scale})`;
    item.style.zIndex = zIndex;
    item.style.opacity = 1;
    if (Math.abs(slideProgress) >= 3) {
      item.style.opacity = 0;
    }
  })
}

const handleSetTransition = (swiper: SwiperType, transition: number) => {
  swiper.slides.forEach((item: any) => {
    item.style.transitionDuration = `${transition}ms`
  })
}
const moduleList = ref([Autoplay])


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Swiper), {
        modules: moduleList.value,
        loop: true,
        autoplay: { delay: 2000 },
        "slides-per-view": "auto",
        "watch-slides-progress": true,
        "centered-slides": true,
        "looped-slides": 5,
        pagination: {
          clickable: true
        },
        onSwiper: setSwiperInstance,
        onProgress: handleProgress,
        onSetTransition: handleSetTransition,
        onClick: handleSwiperClick
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      class: "it_cardImg",
                      src: item.url,
                      alt: "硬件"
                    }, null, 8, _hoisted_7)
                  ]),
                  _createElementVNode("h4", _hoisted_8, _toDisplayString(item.title), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(item.content), 1),
                  _createVNode(_component_router_link, {
                    to: item.to,
                    class: "it_cardLink"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"])
    ]),
    _hoisted_11
  ]))
}
}

})